import { render, staticRenderFns } from "./ClassroomTimetable.vue?vue&type=template&id=47e23c80"
import script from "./ClassroomTimetable.vue?vue&type=script&lang=js"
export * from "./ClassroomTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports